<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

function onClick() {
  router.push(`/account/api/docu`);
}
</script>

<template>
  <div class="card h-100">
    <div class="card-body">
      <div class="row mt-3">
        <div class="card-header">
          <div class="text-center">
            <h2>Intégrate con Beedelivery</h2>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 text-center mt-3 mb-5">
            <h4 class="text-muted">
              Revoluciona tu gestión logística con Beedelivery.
            </h4>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-wrap gap-3 justify-content-center align-items-center">
          <a
            class="btn btn-outline-primary btn-xs"
            @click="onClick"
          >
            <i class="fas fa-book me-2"></i>
            Documentación
          </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>